import { FIXED_INDENTS } from 'vars/index'

export const DropdownItemsGroupDirection = {
  Row: 'row',
  Column: 'column',
} as const
export type DropdownItemsGroupDirection =
  (typeof DropdownItemsGroupDirection)[keyof typeof DropdownItemsGroupDirection]

export const DropdownItemsGroupJustifyContent = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  SpaceBetween: 'space-between',
  SpaceAround: 'space-around',
  SpaceEvenly: 'space-evenly',
} as const
export type DropdownItemsGroupJustifyContent =
  (typeof DropdownItemsGroupJustifyContent)[keyof typeof DropdownItemsGroupJustifyContent]

export const DropdownItemsGroupAlignItems = {
  FlexStart: 'flex-start',
  Center: 'center',
  FlexEnd: 'flex-end',
  Baseline: 'baseline',
} as const
export type DropdownItemsGroupAlignItems =
  (typeof DropdownItemsGroupAlignItems)[keyof typeof DropdownItemsGroupAlignItems]

type PaddingKey = 'SIZE_0' | 'SIZE_20' | 'SIZE_30'
export const DropdownItemsGroupPaddings: Record<
  PaddingKey,
  readonly [string, string, string, string]
> = {
  SIZE_0: [
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_20: [
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_20,
    FIXED_INDENTS.INDENT_0,
  ],
  SIZE_30: [
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_0,
    FIXED_INDENTS.INDENT_30,
    FIXED_INDENTS.INDENT_0,
  ],
} as const
export type DropdownItemsGroupPadding =
  (typeof DropdownItemsGroupPaddings)[keyof typeof DropdownItemsGroupPaddings]
